export default {
  props: {
    name: {
      required: true,
      type: String,
    },
  },
}
